module.exports = __webpack_public_path__ + "static/img/4.f254db2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/eng/4.png
// module id = z64V
// module chunks = 0